import styled from 'styled-components';

const Title = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: palevioletred;
`;

export default Title;


// WEBPACK FOOTER //
// ./src/components/Title.js